import Vue from 'vue'
// import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'

// app.js
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

// swiper

// import VueAwesomeSwiper from "vue-awesome-swiper";
// import "swiper/css/swiper.css";
// Vue.use(VueAwesomeSwiper);

// app.js
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

Vue.config.productionTip = false


import 'animate.css';

import api from './api' // 导入api接口
Vue.prototype.$api = api; // 将api挂载到vue的原型上

// import Viewer from 'v-viewer'
// import 'viewerjs/dist/viewer.css'
// Vue.use(Viewer)
// Viewer.setDefaults({
//   // 需要配置的属性 注意属性并没有引号
//   title: false,
//   toolbar: false
// })


import wx from 'weixin-js-sdk';
Vue.prototype.$wx = wx; 

import wechat from '@/plugins/wechat';
Vue.prototype.$wechat = wechat; 

import extend from '@/plugins/extend';
Vue.prototype.$extend = extend; 

import loading from './plugins/loading'
Vue.use(loading)

import ba from 'vue-ba'
Vue.use(ba, '492ec6c0ced069404149ebe4b9069482')

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
